const config = {
    default: {
        apiUrl: 'https://calculators-api.dev.homeloanexperts.net.au/postcode',
        emailUrl: 'https://notification.dev.homeloanexperts.net.au/api',
        enquiryAPIUrl: 'https://enquiry-form-api.dev.homeloanexperts.net.au',
        googleTagManagerId:'GTM-TX7XV4H'
        
    },
    dev: {
        apiUrl: 'https://calculators-api.dev.homeloanexperts.net.au/postcode',
        emailUrl: 'https://notification.dev.homeloanexperts.net.au/api',
        enquiryAPIUrl: 'https://enquiry-form-api.dev.homeloanexperts.net.au',
        googleTagManagerId:'GTM-TX7XV4H'
    },
    uat: {
        apiUrl: 'https://postcode-api.uat.homeloanexperts.net.au',
        emailUrl: 'https://notification.uat.homeloanexperts.net.au/api',
        enquiryAPIUrl: 'https://enquiry-form-api.uat.homeloanexperts.net.au',
        googleTagManagerId:'GTM-TX7XV4H'
    },
    prod: {
        apiUrl: 'https://postcode-api.homeloanexperts.com.au',
        emailUrl: 'https://notification.homeloanexperts.com.au/api',
        enquiryAPIUrl: 'https://enquiry-form-api.homeloanexperts.com.au',
        googleTagManagerId:'GTM-KLV2WL'
    }
};

const react_script_env = process.env.REACT_APP_ENV;

function getEnvironment() {
    var env;
    switch (react_script_env) {
        case 'LOCAL':
            env = 'default';
            break;
        case 'DEV':
            env = 'dev';
            break;
        case 'UAT':
            env = 'uat';
            break;
        case 'PROD':
            env = 'prod';
            break;
        default:
            env = 'default';
    }
    return env;
}
const env = getEnvironment();

export default config[env];
